/* eslint-disable max-lines */
import { NYTreeStyleImage } from './new-year-tree-types';

export const NEW_YEAR_TREE_PATH = '/promo/stili-novogodnih-elok/';
export const NEW_YEAR_TREE_ELEMENT_BLOCK = 'landingChristmasTrees';
export const NEW_YEAR_TREE_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/new-year-tree-mf';
export const NEW_YEAR_TREE_LANDING_NAME = 'new-year-tree';

export const NY_TREE_HEADER_IMAGE_LIST = {
  ldSrcSet: `${NEW_YEAR_TREE_CDN_PATH}/header/1-ld.jpg/1-ld-01.jpg`,
  dSrcSet: `${NEW_YEAR_TREE_CDN_PATH}/header/1-d.jpg/1-d-01.jpg`,
  tSrcSet: `${NEW_YEAR_TREE_CDN_PATH}/header/1-t.jpg/1-t-01.jpg`,
  mSrcSet: `${NEW_YEAR_TREE_CDN_PATH}/header/1-m.jpg/1-m-01.jpg`,
  title: 'Новогодняя ёлка в классическом стиле',
  alt: 'Новогодняя ёлка в классическом стиле',
};

export const NY_MODERN_STYLE_IMAGE_LIST: NYTreeStyleImage[] = [
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/modern/1.jpg/1.jpg`,
    alt: 'Ёлка в современном стиле',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/modern/2.jpg/2.jpg`,
    alt: 'Игрушка на ёлке в современном стиле',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/modern/3.jpg/3.jpg`,
    alt: 'Подарок под елкой в современном стиле',
  },
];

export const NY_CLASSIC_IMAGE_LIST: NYTreeStyleImage[] = [
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/classic/1.jpg/1-01.jpg`,
    alt: 'Ёлка в классическом стиле',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/classic/2.jpg/2-01.jpg`,
    alt: 'Украшение в классическом стиле',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/classic/3.jpg/3-01.jpg`,
    alt: 'Подарок в классическом стиле в интерьере',
  },
];

export const NY_ROSE_GOLD_IMAGE_LIST: NYTreeStyleImage[] = [
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/rose-gold/1.jpg/1-01.jpg`,
    alt: 'Ёлка в стиле розовое золото',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/rose-gold/2.jpg/2-01.jpg`,
    alt: 'Верхушка ёлки в стиле розовое золото',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/rose-gold/3.jpg/3-01.jpg`,
    alt: 'Ёлка в стиле розовое золото в интерьере гостиной',
  },
];

export const NY_FROSTY_NIGHT_IMAGE_LIST: NYTreeStyleImage[] = [
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/frosty-night/1.jpg/1-01.jpg`,
    alt: 'Ёлка в стиле морозная ночь',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/frosty-night/2.jpg/2-01.jpg`,
    alt: 'Верхушка ёлки в стиле морозная ночь',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/frosty-night/3.jpg/3-01.jpg`,
    alt: 'Ёлка в стиле морозная ночь в интерьере гостиной',
  },
];

export const NY_WINTER_TALE_IMAGE_LIST: NYTreeStyleImage[] = [
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/winter-tale/1.jpg/1-01.jpg`,
    alt: 'Ёлка в стиле зимняя сказка',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/winter-tale/2.jpg/2-01.jpg`,
    alt: 'Украшения для ёлки в стиле зимняя сказка',
  },
  {
    src: `${NEW_YEAR_TREE_CDN_PATH}/winter-tale/3.jpg/3-01.jpg`,
    alt: 'Ёлка в стиле зимняя сказка в интерьере гостиной',
  },
];

export const NY_MODERN_STYLE_PRODUCT_ID_LIST: string[] = [
  '89420531',
  '85156543',
  '89420229',
  '89402959',
  '88943045',
  '89420585',
  '89369005',
  '89420671',
  '88579710',
  '89420534',
  '89420736',
  '89420520',
  '89420563',
  '89420690',
  '82279185',
];

export const NY_CLASSIC_PRODUCT_ID_LIST: string[] = [
  '82609248',
  '87036534',
  '87036354',
  '87036536',
  '82604345',
  '88450175',
  '87036545',
  '85129529',
  '87036518',
  '87033415',
  '82184364',
  '84009728',
  '17876324',
  '84749765',
  '85002884',
  '87036407',
  '87036426',
  '87036554',
  '82184370',
  '87036496',
];

export const NY_ROSE_GOLD_PRODUCT_ID_LIST: string[] = [
  '82184365',
  '88449988',
  '85156541',
  '87036488',
  '87008973',
  '82609258',
  '84749763',
  '87009004',
  '87036514',
  '87036342',
  '87033261',
  '88449639',
  '87038499',
  '87036532',
  '87038497',
  '87038492',
  '88449649',
  '87036513',
  '88458679',
  '87033408',
];

export const NY_FROSTY_NIGHT_PRODUCT_ID_LIST: string[] = [
  '85156531',
  '17876359',
  '85156495',
  '84000945',
  '85166740',
  '82609255',
  '84749764',
  '84000934',
  '88449644',
  '85156565',
  '82606897',
  '87038502',
  '87036542',
  '87036559',
  '87036382',
  '87036535',
  '87036378',
  '87036372',
  '84751279',
  '87036350',
];

export const NY_WINTER_TALE_PRODUCT_ID_LIST: string[] = [
  '82606983',
  '87036367',
  '534649',
  '82606922',
  '88579712',
  '82825046',
  '82606989',
  '85002894',
  '85156565',
  '87036555',
  '84009732',
  '87036529',
  '87036544',
  '82606897',
  '87033421',
  '85156563',
  '85127864',
  '87547159',
  '82606895',
  '87036499',
];

export const NY_MODERN_STYLE_SEE_MORE_LINK = '/catalogue/novogodniy-dekor-v-sovremennom-stile/';
export const NY_CLASSIC_SEE_MORE_LINK = '/catalogue/trendy-novogodnego-dekora/v-klassicheskih-tonah/';
export const NY_ROSE_GOLD_SEE_MORE_LINK = '/catalogue/trendy-novogodnego-dekora/v-rozovyh-tonah/';
export const NY_FROSTY_NIGHT_SEE_MORE_LINK = '/catalogue/trendy-novogodnego-dekora/v-sinih-tonah/';
export const NY_WINTER_TALE_SEE_MORE_LINK = '/offer/elka-v-svetlyh-cvetah/';
